import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import XYZ from "ol/source/XYZ";
import * as olProj from "ol/proj";
import Overlay from "ol/Overlay";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { ImageCanvas, OSM, Vector as VectorSource } from "ol/source";
import { Tile as TileLayer, Vector as VectorLayer, Image as ImageLayer } from "ol/layer";
import Feature from "ol/Feature";
import { Point, MultiLineString, LineString, Polygon, MultiPolygon } from "ol/geom";
import { fromLonLat } from "ol/proj";
import Circle from "ol/geom/Circle";
import { ScaleLine, defaults as defaultControls } from "ol/control";
import LinearRing from "ol/geom/LinearRing";
import { getTransform, transform } from "ol/proj";
import { unByKey } from "ol/Observable";
import WMTS from "ol/source/WMTS";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import * as olExtent from "ol/extent";
import Icon from "ol/style/Icon";
import GeoJSON from "ol/format/GeoJSON";
import { getArea, getLength, getDistance } from "ol/sphere";
import Text from "ol/style/Text";
import TileWMS from "ol/source/TileWMS";
import { Draw, Modify, Snap } from "ol/interaction";
import * as olInteraction from "ol/interaction";
import gcj02Mecator from "./gcj02Mecator";
import { Heatmap as HeatmapLayer } from "ol/layer";
import Vector from 'ol/source/Vector';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';

import axios from 'axios'

import areaGeo from "./xingLong/area.json";
import hld from "./hld.json";

import store from "../../../store"

var localObj = window.location;
var protocol = localObj.protocol + "//"

let apiUrl = localObj.protocol + "//" + localObj.host
if(process.env.NODE_ENV=='developement'){
  apiUrl = "http://192.168.20.208:18030"
}

// 加载底图图层数据
import {
  OSMLayer,
  GoogleLayer,
  GDMapOnline,
  TMStreet,
  TMSatellite,
  TMTitle,
  TMVector
} from "./layers";

// 加载样式
import {
  PointDangerStyle,
  PointInfoStyle,
  PointPrimaryStyle,
  PointSuccessStyle,
  PointWarningStyle,
  SiteDangerStyle,
  SiteInfoStyle,
  SitePrimaryStyle,
  SiteSuccessStyle,
  SiteWarningStyle,
  SiteCustomStyle,
  PointStyle,
  CircleCustomStyle,
  DrawStyle,
  PolygonStyle,
  SectorGreenStyle,
  PointIconStyle,
  PointIconStyle1,
  PointIconStyle2,
  PointIconStyle3,
  currentIconStyle,
  PointIconSxtStyle,
  PointIconQxzStyle,
  PointIconQtzStyle
} from "./style";

export default class MapObject {
  mouseLocation = [0, 0]; // 鼠标当前位置

  zoom = 13; // 当前地图层级

  range = [0, 0]; // 当前可视化区域

  polygonPointList = []; // 绘制完成多边形顶点列表

  drawModify = null;
  drawSnap = null;
  drawDraw = null;
  selectData = null;
  fointIcons = [];
  lastIndex = -1;
  pointsLayer = undefined
  // 构造器函数
  constructor(
    domId = "map-ol",
    center = [116.403694, 39.924896],
    zoom = this.zoom,
    layerType = "TSM",
    config = {},
    list = [],
    show = false
  ) {
    // 创建地图
    this.type = ''
    this.dwBs = false//是否是经过定位
    this.map = new Map({
      target: domId,
      view: new View({
        center: fromLonLat(center),
        zoom,
        constrainResolution: true, // 设置缩放级别为整数
        smoothResolutionConstraint: false, // 关闭无级缩放地图
        minZoom: 1,
        maxZoom: 18
      }),
      interactions: new olInteraction.defaults({
        doubleClickZoom: false, // 屏蔽双击放大事件
      }),
    });
    if (config.scale) {
      // 添加比例尺
      this.addScale();
    }
    if (config.mouseMove) {
      this.mouseMoveOnMap();
    }
    if (config.mapMoved) {
      this.mapMovedOnMap();
    }
    if (layerType == 'TSLM') {
      this.getUnderlayLayerByName(layerType).forEach((layer) => {
        this.map.addLayer(layer);
      });
    }else if (layerType == 'TSLV') {
      this.addTSLV(layerType, list, show)
    }else {
      this.addWAPIAN(layerType, list, show)
    }
    // this.addWAPIAN(layerType,list,show)
    // this.map.addLayer(this.getUnderlayLayerByName(layerType));

    // 点击地图展示弹窗
    const popup = new Overlay({
      element: document.getElementById('popup'),
      positioning: 'bottom-center',       //相对于其位置属性的实际位置
      stopEvent: false,                   //事件冒泡
    });
    this.map.addOverlay(popup);
    this.map.on("click", (e) => {

      let feature = this.map.forEachFeatureAtPixel(e.pixel, function (feature, layerVetor) { return feature; });
      //  console.log(feature.id_, '点击地图')
      if (feature) {
        console.log('You clicked a point icon!');
        let obj = {
          Visnle: true,
          id: feature.id_
        }
        store.commit('dialogVisible', obj)
      }
      // let element = popup.getElement();       // 获取弹窗的DOM元素
      // var coordinate = e.coordinate;		//当前位置信息
      // console.log(coordinate)
      // popup.setPosition(coordinate); 			//设置当前位置
      // featuerInfo = feature.getProperties().features[0].N.geometry.A;
      // featuerInfo = feature.getProperties().features[0].N.attribute;
      // element.innerHTML = '<code>' + '自定义内容展示' + '</code>';	//弹窗内容

      // addFeatrueInfo(featuerInfo); //在popup中加载当前要素的具体信息
      // if (popup.getPosition() == undefined) {
      //     popup.setPosition(coordinate);
      // }
    })
    setTimeout(() => {
      if (list && list.length > 0) {
        this.addPolygon("wjwDraw", list);
      } else {
        if (show) {
          this.addPointIcons('wjwDraw', [{ longitude: Number(center[0]), latitude: Number(center[1]), type: 'danger' }])
        }
      }
    }, 100);

  }

  // 加载本地瓦片图
  addWAPIAN(layerType) {
    let openStreetMapLayer = new TileLayer({
      source: new XYZ({
        url: apiUrl + '/t4/tianditu?T=cva_w&tk=207a7b31f8588ba2a8df864d967b6c15&x={x}&y={y}&l={z}'
      })
    });
    const tileLayer = new TileLayer({
      source: new XYZ({
        url: apiUrl + '/t3/tianditu?T=img_w&tk=207a7b31f8588ba2a8df864d967b6c15&x={x}&y={y}&l={z}'
      })
    })
    this.map.addLayer(openStreetMapLayer);
    this.map.addLayer(tileLayer);
    // this.map.addLayer(this.getUnderlayLayerByName(layerType));
  }

  // 多次访问渲染问题
  addTSLV(layerType) {
    let openStreetMapLayer = new TileLayer({
      source: new XYZ({
        url: apiUrl + '/t4/tianditu?T=cva_w&tk=207a7b31f8588ba2a8df864d967b6c15&x={x}&y={y}&l={z}'
      })
    });
    const tileLayer = new TileLayer({
      title: "underlayLayer",
      className:'blueLayer',//增加className属性
      source: new XYZ({
        url: apiUrl+"/t3/tianditu?T=vec_w&x={x}&y={y}&l={z}&tk=207a7b31f8588ba2a8df864d967b6c15",
      }),
      zIndex: 0,
    })
    this.map.addLayer(openStreetMapLayer);
    this.map.addLayer(tileLayer);
    // this.map.addLayer(this.getUnderlayLayerByName(layerType));
  }

  // 添加比例尺
  addScale() {
    let control = new ScaleLine({});
    this.map.addControl(control);
  }

  // 鼠标移动事件
  mouseMoveOnMap() {
    this.map.on("pointermove", (ev) => {
      let mouse = ev.coordinate; // 获取 3857 坐标
      this.mouseLocation = transform(mouse, "EPSG:3857", "EPSG:4326"); // 坐标转换
      this.map.getTargetElement().style.cursor = 'pointer';
      store.commit('mapConfigChange', { mouseLocation: this.mouseLocation, range: this.range, zoom: this.zoom })
    });
  }

  // 地图移动完成事件
  mapMovedOnMap() {
    this.map.on("moveend", (e) => {
      this.getSize();
    });
  }

  // 获取可视化区域
  getSize() {
    this.zoom = this.map.getView().getZoom();
    let range = this.map.getView().calculateExtent(this.map.getSize());
    let northEast = transform([range[2], range[3]], "EPSG:3857", "EPSG:4326");
    let southWest = transform([range[0], range[1]], "EPSG:3857", "EPSG:4326");
    this.range =
      northEast[0].toFixed(5) +
      "," +
      northEast[1].toFixed(5) +
      " - " +
      southWest[0].toFixed(5) +
      "," +
      southWest[1].toFixed(5);
    store.commit('mapConfigChange', { mouseLocation: this.mouseLocation, range: this.range, zoom: this.zoom })
  }

  // 切换图层
  changeMap(layerTypeName) {
    let underlayLayer = this.getLayerFromMap("underlayLayer");
    let underlayLayerForTMTitle = this.getLayerFromMap(
      "underlayLayerForTMTitle"
    );
    this.map.removeLayer(underlayLayer);
    this.map.removeLayer(underlayLayerForTMTitle);
    this.getUnderlayLayerByName(layerTypeName).forEach((layer) => {
      this.map.addLayer(layer);
    });
  }

  // 根据名称获取可使用底图对象
  getUnderlayLayerByName(layerTypeName) {
    let layers = [];
    console.log(layerTypeName,'map类型')
    switch (layerTypeName) {
      case "GDM":
        layers = [GDMapOnline];
        break;
      case "TSM":
        layers = [TMStreet, TMTitle];
        break;
      case "TSLM":
        layers = [TMSatellite, TMTitle];
        break;
      case "TSLV":
        layers = [TMVector, TMTitle];
        break;
      case "Google":
        layers = [GoogleLayer];
        break;
      default:
        layers = [OSMLayer];
        break;
    }
    return layers;
  }

  // 根据图层名称获取图层
  getLayerFromMap(name) {
    let layers = this.getAllLayers();
    let layer = null;
    layers.forEach((item) => {
      if (item.values_.title !== undefined) {
        if (item.values_.title === name) {
          layer = item;
          return layer;
        }
      }
    });
    return layer;
  }

  // 获取地图引擎加载完成的全部图层
  getAllLayers() {
    return this.map.getLayers();
  }

  /**
   * 根据图层名称， 添加新图层到地图引擎
   * @param {*} layerName 自定义图层名称
   * @param {*} clear 如果存在是否清空之前数据源
   * @param {*} zIndex 底图层级
   * @param {*} opacity 底图透明度
   */
  addVectorLayer(layerName, clear = true, zIndex = 1, opacity = 1) {
    let targetLayer = this.getLayerFromMap(layerName); // 根据图层名称查询是否存在图层
    this.dwBs = false
    if (!targetLayer) {
      // 如果目标图层不存在，则创建
      let source = new VectorSource();
      let layer = new VectorLayer({
        title: layerName,
        opacity,
        zIndex,
      });
      layer.setSource(source);
      this.map.addLayer(layer);
      return layer;
    } else {
      // 获取目标图层下的数据源
      let source = targetLayer.getSource();
      // 清除数据源中原有覆盖物
      if (clear) {
        source.clear();
      }
      return targetLayer;
    }
  }


  /**
   * 根据图层名称， 移除图层上除第一个外的所有元素
   * @param {*} layerName 自定义图层名称
   * @param {*} clear 如果存在是否清空之前数据源
   * @param {*} zIndex 底图层级
   * @param {*} opacity 底图透明度
   */
  removeVectorLayerYs(layerName, clear = true, zIndex = 1, opacity = 1) {
    let targetLayer = this.getLayerFromMap(layerName); // 根据图层名称查询是否存在图层
    if (!targetLayer) {
      // 如果目标图层不存在，则创建
      let source = new VectorSource();
      let layer = new VectorLayer({
        title: layerName,
        opacity,
        zIndex,
      });
      layer.setSource(source);
      this.map.addLayer(layer);
      return layer;
    } else {
      // 获取目标图层下的数据源
      let source = targetLayer.getSource();
      if (this.dwBs) {
        let features = source.getFeatures()
        features.forEach((feature, featureIndex) => {
          // 检查feature的某个属性，例如名为'type'
          if (featureIndex != 0) {
            source.removeFeature(feature);
          } else {
          }
        });
      } else {
        source.clear();
      }

      return targetLayer;
    }
  }

  /**
   * 根据图层名称，在地图引擎移除目标图层
   * @param {*} layerName
   */
  removeVectorLayer(layerName) {
    let targetLayer = this.getLayerFromMap(layerName); // 根据图层名称查询是否存在图层
    if (targetLayer) {
      // 如果存在目标图层
      this.map.removeLayer(targetLayer); // 从地图引擎移除图层
    }
  }

  /**
   * 地图中心坐标位置切换
   * @param {*} center 中心点坐标列表 [经度，纬度]
   * @param {*} duration 移动时间（毫秒）
   */
  setCenter(center, zoom, duration = 1000) {
    this.map.getView().animate({
      // 只设置需要的属性即可
      center: fromLonLat(center), // 中心点
      zoom: zoom,
      duration: duration, // 缩放持续时间，默认不需要设置
    });
  }

  /**
   * 添加坐标点
   * @param {*} layerName 图层名称
   * @param {*} dataList 图层数据列表
   * @param {*} clear 是否清除之前数据
   * @param {*} zIndex 图层层级
   * @param {*} opacity 图层透明度
   */
  addPointIcons(layerName, dataList = [], clear = true, zIndex = 1, opacity = 1) {
    this.addVectorLayer(layerName, clear, zIndex, opacity); // 创建或清空目标图层
    this.fointIcons = []; // 特征集合
    dataList.forEach((item) => {
      let feature = new Feature({
        id: item.id,
        geometry: new Point(fromLonLat([item.longitude, item.latitude])),
      });
      switch (item.type) {
        case "warning":
          feature.setStyle(PointWarningStyle);
          break;
        case "success":
          feature.setStyle(PointSuccessStyle);
          break;
        case "info":
          feature.setStyle(PointInfoStyle);
          break;
        case "danger":
          feature.setStyle(PointDangerStyle);
          break;
        case "type0":
          feature.setStyle(PointIconStyle);
          break;
        case "type1":
          feature.setStyle(PointIconStyle1);
          break;
        case "type2":
          feature.setStyle(PointIconStyle2);
          break;
        case "type3":
          feature.setStyle(PointIconStyle3);
          break;
        case "typeSxt":
          feature.setStyle(PointIconSxtStyle);
          break;
        case "typeQxz":
          feature.setStyle(PointIconQxzStyle);
          break;
        case "typeQtz":
          feature.setStyle(PointIconQtzStyle);
          break;
        default:
          feature.setStyle(PointPrimaryStyle);
      }
      feature.setId(item.id);
      feature.set("data", item);
      this.fointIcons.push(feature);
      this.lastIndex = -1
    });

    // 获取目标图层
    let targetLayer = this.getLayerFromMap(layerName);
    // 获取目标图层下的数据
    let source = targetLayer.getSource();
    source.addFeatures(this.fointIcons);
    this.setMapData(dataList)
    // this.inverseAnalysis()
    if (dataList.length == 1) {
      this.inverseAnalysis(dataList[0].longitude, dataList[0].latitude)
    }
    // fointIcons[2].setStyle(PointDangerStyle)
  }


  /**
 * 添加鼠标滑过坐标点事件
 * @param {*} fn 回调函数
 */
  addPointerMoveMarkerEvent(fn) {
    this.map.on('pointermove', (e) => {
      let pixel = this.map.getEventPixel(e.originalEvent);
      var feature = this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
        return feature;
      });
      fn(feature || null)
    })
  }

  /**
   * 添加点击坐标点事件
   * @param {*} fn 回调函数
   */
  addClickMarkerEvent(fn) {
    this.map.on('click', (e) => {
      let feature = this.map.forEachFeatureAtPixel(e.pixel, function (feature, layer) { return feature; });
      if (feature) {
        fn(feature)
      }
    })
  }

  /**
     * 添加坐标点并保留之前坐标
     * @param {*} layerName 图层名称
     * @param {*} dataList 图层数据列表
     * @param {*} clear 是否清除之前数据
     * @param {*} zIndex 图层层级
     * @param {*} opacity 图层透明度
     */
  addOtherPointIcons(layerName, dataList = [], clear = true, zIndex = 1, opacity = 1) {
    this.removeVectorLayerYs(layerName, clear, zIndex, opacity); // 创建或清空目标图层
    this.fointIcons = []; // 特征集合
    dataList.forEach((item) => {
      let feature = new Feature({
        id: item.id,
        geometry: new Point(fromLonLat([item.longitude, item.latitude])),
      });
      switch (item.type) {
        case "warning":
          feature.setStyle(PointWarningStyle);
          break;
        case "success":
          feature.setStyle(PointSuccessStyle);
          break;
        case "info":
          feature.setStyle(PointInfoStyle);
          break;
        case "danger":
          feature.setStyle(PointDangerStyle);
          break;
        default:
          feature.setStyle(PointPrimaryStyle);
      }
      feature.setId(item.id);
      feature.set("data", item);
      this.fointIcons.push(feature);
    });

    // 获取目标图层
    let targetLayer = this.getLayerFromMap(layerName);
    // 获取目标图层下的数据
    let source = targetLayer.getSource();
    source.addFeatures(this.fointIcons);
    this.setMapData(dataList)
    // fointIcons[2].setStyle(PointDangerStyle)
  }

  /**
   * 添加坐标点
   * @param {*} layerName 图层名称
   * @param {*} dataList 图层数据列表
   * @param {*} clear 是否清除之前数据
   * @param {*} zIndex 图层层级
   * @param {*} opacity 图层透明度
   */
  addSiteIcons(
    layerName,
    dataList = [],
    custom = {},
    clear = true,
    zIndex = 1,
    opacity = 1
  ) {
    this.addVectorLayer(layerName, clear, zIndex, opacity); // 创建或清空目标图层
    let features = []; // 特征集合
    dataList.forEach((item) => {
      let feature = new Feature({
        id: item.id,
        geometry: new Point(fromLonLat([item.longitude || item[0], item.latitude || item[1]])),
      });
      if (custom.img) {
        SiteCustomStyle.src = custom.img
        feature.setStyle(SiteCustomStyle);
      } else {
        if (item.img) {
          SiteCustomStyle.src = item.img
          feature.setStyle(SiteCustomStyle);
        } else {
          switch (item.type) {
            case "warning":
              feature.setStyle(SiteWarningStyle);
              break;
            case "success":
              feature.setStyle(SiteSuccessStyle);
              break;
            case "info":
              feature.setStyle(SiteInfoStyle);
              break;
            case "danger":
              feature.setStyle(SiteDangerStyle);
              break;
            default:
              feature.setStyle(SitePrimaryStyle);
          }
        }

      }

      feature.setId(item.id);
      feature.set("data", item);
      features.push(feature);
    });
    // 获取目标图层
    let targetLayer = this.getLayerFromMap(layerName);
    // 获取目标图层下的数据
    let source = targetLayer.getSource();
    source.addFeatures(features);
  }

  /**
   * 添加点标识
   * @param {*} layerName 图层名称
   * @param {*} dataList 数据列表
   * @param {*} color 点坐标颜色
   * @param {*} radius 点坐标半径
   * @param {*} clear 是否清除之前数据
   * @param {*} zIndex 图层层级
   * @param {*} opacity 图层透明度
   */
  addPoint(
    layerName,
    dataList = [],
    color = "red",
    radius = 5,
    clear = true,
    zIndex = 1,
    opacity = 1
  ) {
    this.addVectorLayer(layerName, clear, zIndex, opacity); // 创建或清空目标图层

    // 获取目标图层
    let targetLayer = this.getLayerFromMap(layerName);
    // 获取目标图层下的数据
    let source = targetLayer.getSource();
    let features = []; // 特征集合
    dataList.forEach((item) => {
      let feature = new Feature({
        id: item.id,
        geometry: new Point(fromLonLat([item.longitude || item[0], item.latitude || item[1]])),
      });
      feature.setStyle(PointStyle(color, radius));
      feature.setId(item.id);
      feature.set("data", item);
      features.push(feature);
    });
    source.addFeatures(features);
    // this.drawModify = new Modify({
    //   source: source,
    // });
    // this.drawSnap = new Snap({
    //   source: source,
    // });
    // this.drawDraw = new Draw({
    //   source: source,
    //   type: "Polygon",
    // });
  }

  /**
   * 添加覆盖圆
   * @param {*} layerName 图层名称
   * @param {*} dataList 数据列表
   * @param {*} color 覆盖圆颜色
   * @param {*} radius 覆盖圆半径/米
   * @param {*} clear 是否清楚之前图层已有数据
   * @param {*} zIndex 图层层级
   * @param {*} opacity 图层透明度
   */
  addCircle(
    layerName,
    dataList = [],
    color = "red",
    radius = 500,
    clear = true,
    zIndex = 1,
    opacity = 1
  ) {
    this.addVectorLayer(layerName, clear, zIndex, opacity); // 创建或清空目标图层
    let features = []; // 特征集合
    dataList.forEach((item) => {
      let feature = new Feature({
        id: item.id,
        geometry: new Circle(
          fromLonLat([item.longitude, item.latitude]),
          radius
        ),
      });
      feature.setStyle(CircleCustomStyle(color));
      feature.setId(item.id);
      feature.set("data", item);
      features.push(feature);
    });
    // 获取目标图层
    let targetLayer = this.getLayerFromMap(layerName);
    // 获取目标图层下的数据
    let source = targetLayer.getSource();
    source.addFeatures(features);
  }

  /**
   * 鼠标绘制多边形(第一步)
   */
  drawPolygon(layerName = "drawPolygon") {
    return new Promise((resolve, reject) => {
      this.polygonPointList = [];
      this.removeInteractionForPolygon(); // 移除所有交互
      this.addVectorLayer(layerName); // 添加绘制图层
      let targetLayer = this.getLayerFromMap(layerName); // 获取目标图层
      // targetLayer.setStyle(DrawStyle); // 设置样式  遮盖地图展示不完全
      targetLayer.setStyle(PolygonStyle); // 设置样式
      let source = targetLayer.getSource(); // 获取目标图层下的数据
      this.drawModify = new Modify({
        source: source,
      });
      this.drawSnap = new Snap({
        source: source,
      });
      this.drawDraw = new Draw({
        source: source,
        type: "Polygon",
      });
      this.map.addInteraction(this.drawModify);
      this.map.addInteraction(this.drawSnap);
      this.map.addInteraction(this.drawDraw);
      this.drawDraw.on("drawend", (e) => {
        //绘画完成触发时间
        const geometry = e.feature.getGeometry();
        const corrdinates = geometry.getCoordinates();
        let points = [];
        corrdinates[0].forEach((item) => {
          let xy = transform(item, "EPSG:3857", "EPSG:4326"); // 转换成经纬度坐标
          points.push(xy);
        });
        this.polygonPointList = points;
        this.removeInteractionForPolygon();
        resolve(this.polygonPointList);
      });
    });
  }

  /**
   * 编辑绘制图形(第二步)
   */
  editDrawPolygon(layerName = "drawPolygon", zIndex = 1, opacity = 1) {
    let targetLayer = this.getLayerFromMap(layerName); // 根据图层名称查询是否存在图层
    if (!targetLayer) {
      // 如果目标图层不存在，则创建
      let source = new VectorSource();
      let layer = new VectorLayer({
        title: layerName,
        opacity,
        zIndex,
      });
      layer.setSource(source);
      this.map.addLayer(layer);
    } else {
      this.map.addInteraction(this.drawModify);
      this.map.addInteraction(this.drawSnap);
    }

  }

  /**
   * 完成编辑(第三步)
   * @param {*} layerName 图层名称
   */
  finishDrawPolygon(layerName) {
    return new Promise((resolve, reject) => {
      let targetLayer = this.getLayerFromMap(layerName);
      let source = targetLayer.getSource();
      let feature = source.getFeatures()[0];
      const geometry = feature.getGeometry();
      const corrdinates = geometry.getCoordinates();
      let points = [];
      corrdinates[0].forEach((item) => {
        let xy = transform(item, "EPSG:3857", "EPSG:4326");
        points.push(xy.toFixed(5));
      });
      this.polygonPointList = points;
      this.removeInteractionForPolygon();
      resolve(this.polygonPointList);
    });
  }

  /**
   * 移除绘制相关交互(第四步)
   */
  removeInteractionForPolygon() {
    this.map.removeInteraction(this.drawModify);
    this.map.removeInteraction(this.drawSnap);
    this.map.removeInteraction(this.drawDraw);
  }

  /**
   * 添加一个覆盖物
   * @param {*} layerName 图层名称
   * @param {*} polygonPointList 多边形顶点列表
   */
  addPolygon(layerName, polygonPointList) {
    this.addVectorLayer(layerName); // 添加绘制图层
    // this.addVectorLayer(layerName, clear); // 创建或清空目标图层
    console.log(polygonPointList, '数组')
    let targetLayer = this.getLayerFromMap(layerName); // 获取目标图层
    // targetLayer.setStyle(DrawStyle); // 设置样式  遮盖地图展示不完全
    targetLayer.setStyle(PolygonStyle); // 设置样式
    let source = targetLayer.getSource(); // 获取目标图层下的数据
    this.drawModify = new Modify({
      source: source,
    });
    this.drawSnap = new Snap({
      source: source,
    });
    this.drawDraw = new Draw({
      source: source,
      type: "Polygon",
    });
    // this.map.addInteraction(this.drawModify);
    // this.map.addInteraction(this.drawSnap);
    // this.map.addInteraction(this.drawDraw);
    let polygon = new Polygon([polygonPointList]);
    polygon.applyTransform(getTransform("EPSG:4326", "EPSG:3857"));
    let feature = new Feature(polygon);
    feature.setStyle(PolygonStyle);
    source.addFeature(feature);
  }

  /**
   * 添加扇形标识
   * @param layerName 图层名称
   * @param dataList 数据源
   * @param clear 是否清除之前图层数据
   */
  addSectorIcon(layerName = "sectorLayer", dataList = [], clear = true) {
    this.addVectorLayer(layerName, clear); // 创建或清空目标图层
    let features = []; // 特征集合
    dataList.forEach((item) => {
      let feature = new Feature({
        id: item.id,
        geometry: new Point(fromLonLat([item.longitude, item.latitude])),
      });
      feature.setStyle(SectorGreenStyle(item.type, item.angle));
      feature.setId(item.id);
      feature.set("data", item);
      features.push(feature);
      // 获取目标图层
      let targetLayer = this.getLayerFromMap('layerName');
      // 获取目标图层下的数据
      let source = targetLayer.getSource();
      source.addFeatures(features);
    });
  }

  /**
   * 点击选择坐标点
   * @param
   * @param
   * @param
   */
  MapClick(e, _this, type = 1) {
    let mouse = e.coordinate;
    let mouseLocation = transform(mouse, "EPSG:3857", "EPSG:4326"); // 坐标转换
    this.polygonPointList = mouseLocation
    if (this.type == 'drawPolygon') {
      return
    }
    if (type == 1) {
      _this.addPoint('wjwDraw', [{ longitude: mouseLocation[0], latitude: mouseLocation[1] }])
    } else if (type == 2) {
      _this.addSiteIcons('wjwDraw', [{ longitude: mouseLocation[0], latitude: mouseLocation[1] }])
    } else {
      _this.addPointIcons('wjwDraw', [{ longitude: mouseLocation[0], latitude: mouseLocation[1], type: 'danger' }])
    }

  }

  /**
   * 注册地图点击事件
   * @param type 点击类型1为标注 2为坐标点 3为自定义标注
   * @param
   * @param
   */
  registClick(type = 1) {
    if (type == 0) {
      this.type = 'drawPolygon'
    } else {
      this.type = type
    }
    // 切换清空图层
    this.removeInteractionForPolygon();
    this.removeVectorLayer("wjwDraw");
    this.map.addEventListener("click", e => this.MapClick(e, this, type));
  }


  // this.type='drawPolygon'
  // addSectorIcon(layerName = "sectorLayer", dataList = [], clear = true) {
  //   this.addVectorLayer(layerName,); // 创建或清空目标图层
  // }
  /**
   * 获取选中的坐标点
   * @param type 点击类型1为标注 2为坐标点 3为自定义标注
   * @param
   * @param
   */

  getPolygon() {
    return new Promise((resolve, reject) => {
      resolve(this.polygonPointList);
    });
  }

  /**
   * 搜索可视区域内的位置
   * @param query 关键词
   * @param
   * @param
   */
  searchQuery(query = '') {
    return new Promise((resolve, reject) => {
      let jw = this.range.toString().replace("-", ",");
      let str = 'type=query&tk=207a7b31f8588ba2a8df864d967b6c15'
      let postStr = { "keyWord": query, "count": 100 }
      if (this.selectData) {
        postStr.queryType = 1
        postStr.level = this.selectData.level
        postStr.cityCode = this.selectData.cityCode
        postStr.mapBound = this.selectData.bound
      } else {
        postStr.queryType = 2
        postStr.zoom = this.zoom
        postStr.mapBound = this.range.replace('-', ',')
      }
      str += '&postStr=' + JSON.stringify(postStr)
      axios({
        url: protocol + 'api.tianditu.gov.cn/v2/search?' + str,
        methods: 'get',
      }).then(res => {
        console.log(res);
        console.log("g成功")
        resolve(res.data.pois);
      }).catch(err => {
        console.log(err);
        console.log("失败");
      })
    });
  }

  /**
   * 搜索可视区域内的位置
   * @param query 关键词
   * @param
   * @param
   */
  searchZb(query = '') {
    return new Promise((resolve, reject) => {
      let isJW = false
      if (query.split(",").length == 2) {
        //可能为经纬度集合
        let jdz = Number(query.split(",")[0])
        let wdz = Number(query.split(",")[1])
        let pointLen = 2
        // 经度范围：0-180，小数部分至少3位
        const lngRegExp = new RegExp(`^([0-9]|[1-9][0-9]|1[0-7][0-9]|180)(\\.\\d{${pointLen},})?$`);

        // 纬度范围：0-90，小数部分至少3位
        const latRegExp = new RegExp(`^([0-9]|[1-8][0-9]|90)(\\.\\d{${pointLen},})?$`);

        const isLng = lngRegExp.test(jdz);
        const isLat = latRegExp.test(wdz);
        if (isLng && isLat) {
          this.setCenter([jdz, wdz], 17)
          this.addPointIcons('wjwDraw', [{ longitude: jdz, latitude: wdz, type: 'danger' }])
          this.dwBs = true
          resolve(true)
        } else {
          resolve(false)
        }

      } else {
        resolve(false)
      }
    })

  }

  /**
   * 选择省市区
   * @param code 省市区/县的code
   * @param
   * @param
   */
  selectArea(code = '', label = '') {
    axios({
      url: protocol + 'api.tianditu.gov.cn/v2/administrative?keyword=' + code + '&tk=207a7b31f8588ba2a8df864d967b6c15',
      methods: 'get',
    }).then(res => {
      console.log(res);
      this.selectData = res.data.data.district[0].center
      this.selectData.specify = res.data.data.district[0].gb
      this.setCenter([this.selectData.lng, this.selectData.lat], 17)
    }).catch(err => {
      console.log(err);
      console.log("失败");
    })
  }

  /**
   * 地址逆解析
   * @param lon 经度
   * @param lat 纬度
   * @param
   */
  inverseAnalysis(lon = '', lat = '') {
    axios({
      url: protocol + "api.tianditu.gov.cn/geocoder?postStr={'lon':" + lon + ",'lat':" + lat + ",'ver':1}&type=geocode&tk=207a7b31f8588ba2a8df864d967b6c15",
      methods: 'get',
    }).then(res => {
      console.log(res);
      res.data.result.addressComponent.lon = lon.toFixed(5)
      res.data.result.addressComponent.lat = lat.toFixed(5)
      store.commit('mapMesChange', res.data.result.addressComponent)
    }).catch(err => {
      console.log(err);
      console.log("失败");
    })
  }
  /**
   * 改变坐标点的样式
   * @param index 第几个
   * @param
   * @param
   */
  changePointStyle(index = 0, type) {
    if (this.lastIndex > -1) {
      switch (type) {
        case "warning":
          this.fointIcons[this.lastIndex].setStyle(PointWarningStyle);
          break;
        case "success":
          this.fointIcons[this.lastIndex].setStyle(PointSuccessStyle);
          break;
        case "info":
          this.fointIcons[this.lastIndex].setStyle(PointInfoStyle);
          break;
        case "danger":
          this.fointIcons[this.lastIndex].setStyle(PointDangerStyle);
          break;
        case "type0":
          this.fointIcons[this.lastIndex].setStyle(PointIconStyle);
          break;
        case "type1":
          this.fointIcons[this.lastIndex].setStyle(PointIconStyle1);
          break;
        case "type2":
          this.fointIcons[this.lastIndex].setStyle(PointIconStyle2);
          break;
        case "type3":
          this.fointIcons[this.lastIndex].setStyle(PointIconStyle3);
          break;
        case "typeSxt":
          this.fointIcons[this.lastIndex].setStyle(PointIconSxtStyle);
          break;
        case "typeQxz":
          this.fointIcons[this.lastIndex].setStyle(PointIconQxzStyle);
          break;
        case "typeQtz":
          this.fointIcons[this.lastIndex].setStyle(PointIconQtzStyle);
          break;
        default:
          this.fointIcons[this.lastIndex].setStyle(PointPrimaryStyle);
      }
      // this.fointIcons[this.lastIndex].setStyle(PointPrimaryStyle)
    }
    this.fointIcons[index].setStyle(currentIconStyle)
    this.lastIndex = index
  }
  // http://lbs.tianditu.gov.cn/api/js4.0/opensource/data/points-sample-data.js
  /**
     * 改变坐标点的样式
     * @param index 第几个
     * @param
     * @param
     */
  selectPoint(mouseLocation) {
    console.log('xua')
    this.addPointIcons('wjwDraw', [{ longitude: mouseLocation[0], latitude: mouseLocation[1], type: 'danger' }], fae)
  }

  /**
   * 添加海量点
   * @param
   * @param
   * @param
   */
  addWebGL(layerName, dataList = [], clear = true, zIndex = 1, opacity = 1) {
    let vectorSource = new Vector({
      url: protocol + 'openlayers.org/en/latest/examples/data/geojson/world-cities.geojson',
      format: new GeoJSON(),
      wrapX: true,
    });
    var previousLayer = new WebGLPointsLayer({
      source: vectorSource,
      style: {
        symbol: {
          symbolType: 'circle',
          size: [
            'interpolate',
            ['linear'],
            ['get', 'population'],
            40000,
            5,
            2000000,
            8],
          color: [
            'interpolate',
            ['linear'],
            ['get', 'latitude'],
            -80,
            '#ff14c3',
            -20,
            '#ff621d',
            20,
            '#ffed02',
            80,
            '#00ff67'],
          offset: [0, 0],
          opacity: 0.95,
        }
      },
      disableHitDetection: true,
    });
    // console.log(this.pointsLayer)

    this.map.addLayer(previousLayer);
    // let source = vectorSource.getSource();
    // source.addFeatures(this.pointsLayer);
    // let targetLayer = this.getLayerFromMap('underlayLayer'); // 根据图层名称查询是否存在图层
    // console.log(targetLayer)
    // let source = vectorSource.getSource();
    // source.addFeatures(this.pointsLayer);
    // this.map.addLayer(this.pointsLayer);
    // if (previousLayer) {
    //   this.map.removeLayer(previousLayer);
    //   previousLayer.dispose();
    // }
  }

  /**
   * 添加海量点(自定义点)
   * @param
   * @param
   * @param
   */
  addWebGLCust(layerName, dataList = [], clear = true, zIndex = 1, opacity = 1) {
    var b = hld
    let iconFeatureArr = b.map((v) => {
      var iconFeature = new Feature({
        //feature-矢量集合图形
        geometry: new Point(
          transform([v.jd, v.wd], "EPSG:4326", "EPSG:3857")
        ),//生成集合体的形状是一个点
        data: v, //原数据--将要保存的点位数据存到集合体中，在点位交互的时候可以直拿到
        population: 40000,
        rainfall: 500,
      });
      let iconStyle = new Style({//点位样式
        image: new Icon({
          anchor: [0.5, 0.5],
          anchorXUnits: "fraction",
          anchorYUnits: "pixels",
          width: 40,
          height: 40,
          src: protocol + 'api.tianditu.gov.cn/img/map/markerA.png',
        }),
      });
      iconFeature.setStyle(iconStyle);
      return iconFeature
    });
    let vectorSource = new VectorSource({
      features: iconFeatureArr,
    });

    let vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    vectorLayer.on("singleclick", function (evt) {
      console.log(evt, 999)
    });
    //加入点位
    this.map.addLayer(vectorLayer);
    // let source = vectorSource.getSource();
    // source.addFeatures(this.pointsLayer);
    // let targetLayer = this.getLayerFromMap('underlayLayer'); // 根据图层名称查询是否存在图层
    // console.log(targetLayer)
    // let source = vectorSource.getSource();
    // source.addFeatures(this.pointsLayer);
    // this.map.addLayer(this.pointsLayer);
    // if (previousLayer) {
    //   this.map.removeLayer(previousLayer);
    //   previousLayer.dispose();
    // }
  }

  // 创建 GeoJSON 图层 （针对省市区）
  addGeojson(data) {
    const layers = new VectorLayer({
      source: new VectorSource({
        features: new GeoJSON().readFeatures(data, { featureProjection: 'EPSG:3857' })
      }),
      style: new Style({
        // fill: new Fill({
        //   color: 'rgba(135,135,135,0.3)'
        // }),
        stroke: new Stroke({
          color: "#3e7fff", // 描边颜色
          width: 2 // 设置描边宽度为 2 像素
        }),
      })
    });

    this.map.addLayer(layers);
  }
  arr(options, layerName, clear = true, zIndex = 1, opacity = 1) {
    let targetLayer = this.getLayerFromMap(layerName); // 根据图层名称查询是否存在图层
    console.log(targetLayer, 9655525)
    if (!targetLayer) {
    } else {
      // 获取目标图层下的数据源
      let source = targetLayer.getSource();
      // 清除数据源中原有覆盖物
      if (clear) {
        source.clear();
      }
    }

    // 如果目标图层不存在，则创建
    let vectorSource = new VectorSource();
    options.forEach((item, index) => {
      vectorSource.addFeature(new Feature({
        geometry: new Point(fromLonLat([item.jd, item.wd])),
        name: item.baseName,
        style: new Style({
          text: new Text({
            text: item.baseName,
            scale: 1.5,
            offsetX: 0,
            offsetY: -60,
            fill: new Fill({
              color: '#ffb74e'
            }),
            stroke: new Stroke({
              color: 'rgba(3, 26, 39, 0.8)',
              width: 3
            })
          })
        })
      }));
    })
    // let source = new VectorSource();
    // let layer = new VectorLayer({
    //   title: layerName,
    //   opacity,
    //   zIndex,
    // });
    // layer.setSource(source);
    const vectorLayer = new VectorLayer({
      title: layerName,
      source: vectorSource,
      style: function (feature) {
        return feature.get('style');
      }
    });
    this.map.addLayer(vectorLayer);
  }

  arr1(options, layerName, clear = true, zIndex = 1, opacity = 1) {

    const vectorSource = new VectorSource();
    // 添加标签到VectorSource
    options.forEach((item, index) => {
      vectorSource.addFeature(new Feature({
        geometry: new Point(fromLonLat([item.jd, item.wd])),
        name: item.baseName,
        style: new Style({
          text: new Text({
            text: item.baseName,
            scale: 1.5,
            offsetX: 0,
            offsetY: -40,
            fill: new Fill({
              color: '#ffb74e'
            }),
            stroke: new Stroke({
              color: 'rgba(3, 26, 39, 0.8)',
              width: 3
            })
          })
        })
      }));
    })
    // vectorSource.addFeature(new Feature({
    //   geometry: new Point([0, 0]),
    //   name: 'Feature 2',
    //   style: createLabelStyle('Label 2', 1, 10, 10)
    // }));

    // 创建VectorLayer并将其添加到地图中
    const vectorLayer = new VectorLayer({
      source: vectorSource,
      style: function (feature) {
        return feature.get('style');
      }
    });
    this.map.addLayer(vectorLayer);
  }
  // 设置区域
  addGeojson1(geo = []) {

    const colorList = [
      // 蓝色
      {
        fillColor: "#4e98f444",
        strokeColor: [71, 137, 227, 1],
      },
      // 红色
      {
        fillColor: "#DF002944",
        strokeColor: [223, 0, 41, 1],
      },
      // 橘色
      {
        fillColor: "#EC870E44",
        strokeColor: [236, 135, 14, 1],
      },
      // 黄色
      {
        fillColor: "#F9F40044",
        strokeColor: [249, 244, 0, 1],
      },
      // 绿色
      {
        fillColor: "#5BBD2B44",
        strokeColor: [91, 189, 43, 1],
      },
      // 青色
      {
        fillColor: "#00B2BF44",
        strokeColor: [0, 178, 191, 1],
      },
      // 紫色
      {
        fillColor: "#635BA244",
        strokeColor: [99, 91, 162, 1],
      },
    ]
    geo = areaGeo
    if (geo.length == 0) {
      return false;
    }
    let features = [];
    geo.forEach((g) => {
      let lightArr = [
        g.features[12],
        g.features[22],
        g.features[30],
        g.features[2],
        g.features[4],
        g.features[5],
        g.features[16],
      ];
      lightArr.forEach((item, index) => {
        let lineData3 = item;
        let routeFeature3 = "";
        if (lineData3.geometry.type == "MultiPolygon") {
          routeFeature3 = new Feature({
            geometry: new MultiPolygon(lineData3.geometry.coordinates),
          });
        } else if (lineData3.geometry.type == "Polygon") {
          routeFeature3 = new Feature({
            geometry: new Polygon(lineData3.geometry.coordinates),
          });
        }
        routeFeature3.setStyle(
          new Style({
            fill: new Fill({
              //填充颜色
              color: colorList[index].fillColor,
            }),
            stroke: new Stroke({
              //边界宽度
              width: 3,
              //边界颜色
              color: colorList[index].strokeColor,
            }),
          })
        );
        features.push(routeFeature3);
      });
    });
    // 设置图层
    let routeLayer = new VectorLayer({
      source: new VectorSource({
        features: features,
      }),
      style: new Style({
        stroke: new Stroke({
          color: "#ff0000", // 描边红色
          width: 2 // 设置描边宽度为 1 像素
        }),
        fill: new Fill({
          color: "#ff000020" // 填充红色透明
        })
      })
    });
    // 添加图层

    this.map.addLayer(routeLayer);
  }
  setMapData(data) {
    store.commit('mapDataChange', data)
  }
}
